<template>
    <div>
        <form class="form-inline">
            <div class="form-group">
                <label class="sr-only" for="leafTemperature">Leaf Temp &#8451;</label>
                <input type="number" class="form-control" id="leafTemperature" placeholder="24" v-model="leafTemp">
                <label class="sr-only" for="stage">Leaf Temp &#8451;</label>
                <select class="form-control" id="stage" name="stage" v-model="stage">
                    <option value="clones">Clones</option>
                    <option value="veg">Vegetative</option>
                    <option value="flower">Flowering</option>
                </select>
                <table class="table table-hover table-striped table-borderless">
                    <thead>
                        <tr>
                            <td>&nbsp;</td>
                            <td v-for="humidity in humidityRange" :key="humidity">
                                {{ humidity }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(humidityValues,temp) in vpdArray" :key="temp">
                            <td>{{ humidityValues }}{{ temp }}</td>
                            <td v-for="(vpd, humidity) in humidityValues" :key="humidity">
                                {{ vpd }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                leafTemp: 24,
                stage: 'clones'
            }
        },

        computed: {
            humidityRange() {
                let humidityRange  = [];
                for (let i=100; i > -1; i-=2 ) {
                    humidityRange.push(i);
                }

                return humidityRange;
            },

            tempRange() {
                let tempRange = [];
                for (let i=10; i < 46; i++ ) {
                    tempRange.push(i);
                }
                return tempRange;
            },

            vpdArray() {
                let vpdObj = [];
                for (let temp=0; temp < this.tempRange.length; temp++) {
                    for (let humidity=0; humidity< this.humidityRange.length; humidity++) {
                        vpdObj.push({
                            temp: this.tempRange[temp],
                            humidity: this.humidityRange[humidity],
                            vpd: this.VapourPressureDeficit(this.tempRange[temp] - 2, this.tempRange[temp], this.humidityRange[humidity])
                        })
                    }
                }
                return vpdObj;
            }
        },
        methods:{
            /**
             * Calculates the the Vapour Pressure of 100% saturated air for a given air temperature.
             * Result is in Pa (Pascals)
             *
             * All information and calculations here
             * https://pulsegrow.com/blogs/learn/vpd
             *
             *
             * @param {number} temperature
             * @returns {number}
             * @constructor
             */
            VapourPressureSaturated( temperature = 0.0 ) {
                return 610.78 * Math.exp((temperature/ (temperature+237.3)) * 17.2694);
            },

            /**
             * Calculates the Vapour Pressure of a room for a given temperature and humidity
             *
             * All information and calculations here
             * https://pulsegrow.com/blogs/learn/vpd
             *
             * @param {number} roomTemperature
             * @param {number} relativeHumidity
             * @returns {number}
             * @constructor
             */
            VapourPressureAir( roomTemperature = 0.0, relativeHumidity = 0.0 ) {
                return this.VapourPressureSaturated( roomTemperature ) * (relativeHumidity / 100 );
            },

            /**
             * Calculates the VPD of a leaf/room pairing for a given leaf temp, room temp and room humidity
             *
             * All information and calculations here
             * https://pulsegrow.com/blogs/learn/vpd
             *
             * @param leafTemperature
             * @param roomTemperature
             * @param relativeHumidity
             * @returns {string}
             * @constructor
             */
            VapourPressureDeficit( leafTemperature = 0.0, roomTemperature = 0.0, relativeHumidity = 0.0 ) {
                let vpd = this.VapourPressureSaturated( leafTemperature ) - this.VapourPressureAir( roomTemperature, relativeHumidity );

                return (vpd/1000).toFixed(2);
            }
        }
    }
</script>